import { usePatientStore } from "../../store/Patient";
import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { Button as ShadcnButton } from "@/dentlab/src/components/ui/button";
import { Pin as PinIcon, PinOff as PinOffIcon } from "lucide-react";
import { Tooltip } from "@mui/material";

export const PinPatient: React.FC<{ patient: PatientEntityType }> = ({
	patient,
}) => {
	const { pinPatient, unpinPatient, pinnedPatients } = usePatientStore(
		(state) => ({
			pinPatient: state.pinPatient,
			unpinPatient: state.unpinPatient,
			pinnedPatients: state.pinnedPatients,
		})
	);

	if (!patient.id) return null;
	const isPinned = !!pinnedPatients[patient.id];

	return (
		<Tooltip
			title={isPinned ? "Fixierung entfernen" : "Fixierung hinzufügen"}
		>
			<ShadcnButton
				onClick={() => {
					if (isPinned) {
						unpinPatient(patient.id as string);
					} else {
						pinPatient(patient);
					}
				}}
				size="icon"
				variant="ghost"
				className="w-8 h-8"
			>
				{isPinned ? (
					<PinOffIcon className="w-5 h-5" />
				) : (
					<PinIcon className="w-5 h-5" />
				)}
			</ShadcnButton>
		</Tooltip>
	);
};
